export default __webpack_public_path__ + "static/media/hht2_ep12_speaking_01.85aba6e8.png";